import { useEffect } from 'react';
import { Stack } from '@mui/material';
import { useFormikContext } from 'formik';
import {
  fetchTemplates,
  templateListSelector,
} from '@/features/admin/templates/slice';
import { useAppDispatch, useAppSelector } from '@/hooks';
import { Card } from '@/components';
import { Template } from '@/types';

const WebsiteTemplates = () => {
  const dispatch = useAppDispatch();
  const templates = useAppSelector(templateListSelector) as Template[];
  const { setFieldValue, values } = useFormikContext<{ template: string }>();

  useEffect(() => {
    dispatch(fetchTemplates());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Stack spacing={2} direction={'row'}>
      {templates.map((t) =>
        t.type === 'web' ? (
          <Card
            key={t.id}
            title={t.title}
            actions={[
              {
                variant: 'contained',
                children: values.template === t.id ? 'Elegida' : 'Elegir',
                onClick: () => setFieldValue('template', t.id),
                disabled: values.template === t.id,
              },
            ]}
          />
        ) : null
      )}
    </Stack>
  );
};

export default WebsiteTemplates;
